<template lang="pug">
  #LabelCreate.container-width
    h5.text-center.pt-2 新增顧客標籤
    .px-3
      ValidationObserver.w-100(
        ref="form"
        tag="label"
        @submit.stop.prevent="submitHandler",
        class="mb-0"
      )
        b-form-group(
          class="mb-0"
        )
          ValidationProvider(
            rules="required",
            ref="inputValLabel"
          )
            //- label(
            //-   for="label"
            //- )
            //-   code *
            //-   span 顧客標籤：
            b-form-input(
              id="label",
              type="text",
              required,
              trim,
              :state="validState('label')",
              v-model="label",
              aria-describedby="input-live-help input-name-live-feedback",
              placeholder="請輸入顧客標籤",
            )
            .d-flex
              b-row(
                no-gutters,
                class="w-100"
              )
                b-col(
                  cols=10
                )
                  b-form-invalid-feedback(
                    id="input-name-live-feedback",
                    :class="validState('label') === null || validState('label') === true ? 'd-none' : 'd-block'"
                  )
                    span 此欄不可為空且字數需小於30個字元
                b-col(
                  :cols="validState('label') ? 12 : 2"
                )
                  small.d-block.text-right
                    small(
                      :class="{ 'text-danger': label !== null && label.length > 30 }"
                    ) {{ label !== null ? label.length : 0 }}
                    | /30
      p 標籤內共
        code.px-1 {{ selectUsers.length }}
        | 位名單
      .row.mb-5
        .col-3(
          v-for="(user,index) in selectUsers",
          :key="user.member_id"
        )
          ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
            :id="user.member_id",
            :profileUrl="user.picture_url",
            :cancelProfile="true"
            :style="{ 'width': '50px', 'height': '50px' }"
            @cancelProfileImgHandler="cancelProfileHandler",
          )
          small.d-block.text-center.mt-1 {{ user.line_display_name }}
        .col-3.text-center
          .border.border-gray-light-2.bg-gray-light.rounded-circle.mx-auto.d-flex.align-items-center.justify-content-center.mb-1(
            style="width: 50px;height: 50px;",
            @click="openUsersModelHandler()"
          )
            i.fas.fa-plus.text-disable-light.fa-lg
          small.d-block.text-center 新增
      .row
        .col-6
          b-button.button_custom-primary(
            variant="primary",
            block,
            @click="resetAllHandler()"
          ) 取消
        .col-6
          b-button.button_custom-primary(
            variant="primary",
            block,
            @click="submitHandler()"
          ) 儲存
    usersModel(
      title="選擇顧客",
      :selectUsers='selectUsers'
    )
</template>

<script>
import { mapState } from 'vuex';
import { SA_LABEL_INDEX } from '@/router/sa/label';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import usersModel from '@/components/customerModel/usersModel.vue';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

const _ = require('lodash');

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

export default {
  name: 'LabelCreate',
  components: {
    ValidationProvider,
    ValidationObserver,
    usersModel,
    ProfilePhotoSticker
  },
  data() {
    return {
      label: null
    };
  },
  created() {
    const vm = this;
    // 初始化全部
    vm.$store.commit('sa_label/resetAll');
  },
  methods: {
    validState() {
      const vm = this;
      if (vm.label !== null) {
        return vm.label.length < 30 && vm.label.length > 0;
      }
      return null;
    },
    openUsersModelHandler() {
      this.$EventBus.$emit('openUsersModel', 'ba');
    },
    async submitHandler() {
      const vm = this;
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        if (vm.label === null) {
          vm.label = '';
        }
        vm.$swal.fire({
          icon: 'error',
          title: '請填妥必填欄位或格式輸入錯誤'
        });
      } else {
        vm.$swal.fire({
          title: '新增標籤中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });

        const member_ids = [];

        _.forEach(vm.selectUsers, (res) => {
          member_ids.push(res.member_id);
        });

        vm.$store.dispatch('sa_label/storeTagHandler', {
          tag_name: vm.label,
          member_ids
        })
          .then(() => {
            vm.$swal.close();
            vm.$snotify.success(null, '新增成功');
            vm.resetAllHandler();
          });
      }
    },
    cancelProfileHandler(id) {
      const vm = this;
      const key = _.findKey(vm.selectUsers, (user) => user.member_id === id);
      vm.$store.commit('sa_label/removeSelectUsers', key);
    },
    resetAllHandler() {
      const vm = this;
      vm.$store.commit('sa_label/resetAll');
      vm.$router.push({ name: SA_LABEL_INDEX });
    }
  },
  computed: {
    ...mapState({
      selectUsers: (state) => state.sa_label.selectUsers
    })
  }
};
</script>

<style>

</style>
